// extracted by mini-css-extract-plugin
export var errorIcon = "_ol-1";
export var nameLogo = "_ol-0";